import React from "react";
import { Authorized } from "MODULES/shared/components";
import {
  CAN_ADD_UPDATE_APPLICATIONS,
  ROLES,
  WAREHOUSE,
  WAREHOUSE_LOGISTICS_DIRECTOR
} from "MODULES/users/constants";
import { without } from "lodash";
import New from "./New";
import Table from "./Table";

export default function Applications() {
  return (
    <div>
      <h2>
        Applications
        <Authorized
          roles={without(ROLES, WAREHOUSE)}
          subroles={[WAREHOUSE_LOGISTICS_DIRECTOR]}
          permissions={[CAN_ADD_UPDATE_APPLICATIONS]}
        >
          <New />
        </Authorized>
      </h2>
      <Table />
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/Applications/Applications.jsx